// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #root {
  background-color: white !important;
} */

#loginForm {
  padding: 20px;
  width: 20%;
  margin-left: auto;
  margin-right: auto;
}

#loginTitle {
  font-size: small !important;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  padding: 2%;
}


#loginEmail {
	
}

#loginPassword {
	width: 100%;
}

#loginPasswordContainer {
    position: relative;
}

#loginForgotten {
	position: absolute;
  right: var(--inputPadding);
  top: 50%;
  transform: translateY(-50%);
}

#loginButton {
	background-color: var(--main-hg-color);
}

.loginLink {
	text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.container__loginpage:not(.container__information__register__product) #headerLogo {
    margin-bottom: 50px;
}

@media only screen and (max-width: 768px) {
  #loginForm {
    padding: 5px;
    width: 70%;
  }
  #loginTitle {
    margin-top: 22% !important;
  }
  #loginButton {
    width: 100% !important;
  }
  .btnReverse {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/login.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;;AAGA;;AAEA;;AAEA;CACC,WAAW;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;CACC,kBAAkB;EACjB,0BAA0B;EAC1B,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,kBAAkB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;EACE;IACE,YAAY;IACZ,UAAU;EACZ;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* #root {\n  background-color: white !important;\n} */\n\n#loginForm {\n  padding: 20px;\n  width: 20%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n#loginTitle {\n  font-size: small !important;\n  text-align: center;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 2%;\n}\n\n\n#loginEmail {\n\t\n}\n\n#loginPassword {\n\twidth: 100%;\n}\n\n#loginPasswordContainer {\n    position: relative;\n}\n\n#loginForgotten {\n\tposition: absolute;\n  right: var(--inputPadding);\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n#loginButton {\n\tbackground-color: var(--main-hg-color);\n}\n\n.loginLink {\n\ttext-align: center;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.container__loginpage:not(.container__information__register__product) #headerLogo {\n    margin-bottom: 50px;\n}\n\n@media only screen and (max-width: 768px) {\n  #loginForm {\n    padding: 5px;\n    width: 70%;\n  }\n  #loginTitle {\n    margin-top: 22% !important;\n  }\n  #loginButton {\n    width: 100% !important;\n  }\n  .btnReverse {\n    width: 100% !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
